module.exports = __webpack_public_path__ + "static/media/YM02_4.b465789e.jpg";